import { Flex, Text } from "@chakra-ui/react";
import useFindDisponibilidadeAreaComum from "core/features/area-comum/hooks/useFindDisponibilidadeAreaComum";
import useSaveDisponibilidadeAreaComum from "core/features/area-comum/hooks/useSaveDisponibilidadeAreaComum";
import { AreaComumDisponibilidadeResponse } from "core/features/area-comum/typings";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { useLoading } from "ui/components/GlobalLoading";
import Field from "ui/components/Input/Field";

import RangeDates, { days } from "../RangeDates";

function Disponibilidade({ id }: { id: string }) {
  const { tenant } = useCurrentTenant();

  const { isLoading, mutate: handleSave } = useSaveDisponibilidadeAreaComum(
    tenant.id,
    id
  );

  const { data: defaultData, isFetching } = useFindDisponibilidadeAreaComum(
    tenant.id,
    id
  );

  const _handleSave = (values: AreaComumDisponibilidadeResponse) => {
    handleSave(values, {
      onError: (err) => {
        showErrorAxios(err);
      },
      onSuccess: () => {
        showSuccess();
      },
    });
  };

  const { control, handleSubmit, reset } =
    useForm<AreaComumDisponibilidadeResponse>({
      defaultValues: {
        items: days.map((day) => ({
          dia: day,
          horaFim: "23:59",
          horaInicio: "00:00",
        })),
      },
    });

  useEffect(() => {
    reset({ ...defaultData });
  }, [defaultData, reset]);

  useLoading(isLoading || isFetching);

  if (isFetching) {
    return null;
  }

  return (
    <>
      <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
        Disponibilidade
      </Text>
      <Flex mb="16px" w="100%" gap="8px">
        <Field
          name="items"
          control={control}
          render={({ field }) => <RangeDates {...field} />}
        />
      </Flex>

      <Flex justifyContent={"flex-end"} mt="32px">
        <PrimaryButton
          isDisabled={isLoading || isFetching}
          isLoading={isLoading || isFetching}
          onClick={() => handleSubmit(_handleSave)()}
        >
          Salvar
        </PrimaryButton>
      </Flex>
    </>
  );
}

export default Disponibilidade;
